import axiosGlobalInstance from './configHttpInstance/http-instance';
import mockEnterpriseList from './fakes/enterprise-listing';

const getEnterpriseList = (params) => {
  const useFake = !!Number(process.env.REACT_APP_MOCK_API);

  if(useFake) {
    return new Promise((resolve) => {
      setTimeout(() => resolve(mockEnterpriseList), 1000);
    });
  }

  const { migrationId, ...rest } = params;
  const httpInstance = axiosGlobalInstance();

  return httpInstance({
    method: 'GET',
    url: `/migrations/${migrationId}/enterprises`,
    params: rest
  });
}

export default getEnterpriseList;

